import {Presenter} from './support/with_presenter';
import {GridLoader} from '../business/grid_loader';
import {Employee} from '../models/employee';
import {User} from '../models/user';

export class GridPresenter implements Presenter {
    public compact: boolean = false;

    public offset: number;

    public get internalEmployees(): Employee[] {
        return this.sortEmployees([...this.initialEmployees]).filter((e) => e.type === 'internal');
    }

    public get externalEmployees(): Employee[] {
        return this.sortEmployees([...this.initialEmployees]).filter((e) => e.type === 'external');
    }

    private sortEmployees(employees: Employee[]) {
        return employees.sort((a: Employee, b: Employee) => {
            if (a.id === this.user.employee_id) {
                return -1;
            }
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
    }

    public get weeksInView(): number {
        return this.compact ? 40 : 10;
    }

    constructor(
        private user: User,
        private initialOffset: number,
        private initialEmployees: Employee[],
        private gridLoader: GridLoader,
    ) {
        this.offset = initialOffset;
    }

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public async onBackNavigateClick() {
        const stepSize = this.compact ? 8 : 4;
        const numberOfWeeks = this.compact ? 41 : 11;
        this.offset = this.offset - stepSize;
        await this.gridLoader.fetch(this.offset, numberOfWeeks);
    }

    public async onForwardNavigateClick() {
        const stepSize = this.compact ? 8 : 4;
        const numberOfWeeks = this.compact ? 41 : 11;
        this.offset = this.offset + stepSize;
        await this.gridLoader.fetch(this.offset, numberOfWeeks);
    }

    public async handleCompactClick() {
        this.compact = !this.compact;
        const numberOfWeeks = this.compact ? 41 : 11;
        await this.gridLoader.fetch(this.offset, numberOfWeeks);
    }
}
